import { render, staticRenderFns } from "./LoginAcesso.vue?vue&type=template&id=726738e0"
import script from "./LoginAcesso.vue?vue&type=script&lang=js"
export * from "./LoginAcesso.vue?vue&type=script&lang=js"
import style0 from "./LoginAcesso.vue?vue&type=style&index=0&id=726738e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports